export default "__VITE_ASSET__yiO3Xii___"